import React from 'react'
import './Header.css'
import BloodtypeIcon from '@mui/icons-material/Bloodtype';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { Link } from "react-router-dom"

function Header() {
    return (
        <div className='header'>
            
            <Link to="/privacy">
                <img
                    className="header__icon"
                    src="https://firebasestorage.googleapis.com/v0/b/ahava-4eea9.appspot.com/o/web%2Fahava(1).png?alt=media&token=17d5417d-69c4-4ca6-b59b-264422d4cdbb"
                    alt=""
                />
            </Link>

                <div className='header__right'>
                    <p>Dona Sangre</p>
                    <BloodtypeIcon/>
                    <p>Dona Dinero</p>
                    <AttachMoneyIcon/>
                    <p>Regala Vida</p>
                    <FavoriteIcon/>
                </div>
        </div>
    )
}

export default Header
